module.exports = __webpack_public_path__ + "img/기업검색.15237380.png";